import React from 'react';
const contactEmail = 'support@adora.media';
export const TermContent = ({ withHeader }) => {
    return (<div className="flex flex-col gap-6 leading-relaxed">
            {withHeader && <h1 className="text-3xl font-bold tracking-tight">Terms & Conditions</h1>}

            {/* 1. Introduction */}
            <section className="space-y-2">
                <h2 className="text-xl font-semibold">1. Introduction</h2>
                <p>
                    Welcome to Adora (“we”, “us”, “our”). By accessing or using our platform, you agree to be bound by
                    these Terms & Conditions. Please read them carefully before using the service.
                </p>
            </section>

            {/* 2. Use of Service */}
            <section className="space-y-2">
                <h2 className="text-xl font-semibold">2. Use of Service</h2>
                <p>
                    You agree to use Adora responsibly and comply with all applicable laws and regulations. Misuse of
                    the platform, including attempts to disrupt the service or misuse tracking tools, may result in
                    suspension or termination of your account.
                </p>
            </section>

            {/* 3. Accounts */}
            <section className="space-y-2">
                <h2 className="text-xl font-semibold">3. Accounts</h2>
                <p>
                    You are responsible for maintaining the confidentiality of your login credentials. Any activity
                    performed through your account is considered your responsibility. Notify us immediately if you
                    suspect unauthorized access.
                </p>
            </section>

            {/* 4. Limitation of Liability */}
            <section className="space-y-2">
                <h2 className="text-xl font-semibold">4. Limitation of Liability</h2>
                <p>
                    Adora is provided “as is” and “as available”, without warranties of any kind. We are not liable for
                    indirect, incidental, or consequential damages arising from your use or inability to use the
                    service.
                </p>
            </section>

            {/* 5. Changes */}
            <section className="space-y-2">
                <h2 className="text-xl font-semibold">5. Changes to Terms</h2>
                <p>
                    We may update these Terms & Conditions from time to time. The “last updated” date will reflect
                    changes. Continued use of the platform after updates constitutes acceptance of the revised terms.
                </p>
            </section>

            {/* 6. Contact */}
            <section className="space-y-2">
                <h2 className="text-xl font-semibold">6. Contact</h2>
                <p>
                    If you have questions regarding these Terms & Conditions, contact us at
                    <a href={`mailto:${contactEmail}`} className="text-primary hover:underline">
                        {' '}
                        {contactEmail}
                    </a>
                    .
                </p>
            </section>
        </div>);
};
TermContent.displayName = 'TermContent';
